





































import { defineComponent } from "@vue/composition-api";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import { PaymentPackage, PaymentPackageType } from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import BaseGrid from "@/components/BaseGrid.vue";
import WrapperCheckAuthorities from "@/components/WrapperCheckAuthorities.vue";
import BlockPaymentPackageAdd from "./BlockPaymentPackageAdd.vue";
import BlockPaymentPackage from "./BlockPaymentPackage.vue";

export default defineComponent({
  name: "PaymentPackagesContainer",
  components: { WrapperCheckAuthorities, BaseGrid, BlockPaymentPackageAdd, BlockPaymentPackage },
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    type: { type: String as () => PaymentPackageType, required: true },
    hideCosts: { type: Boolean, default: false },
    addButtonText: { type: String, required: true },
    paymentPackages: { type: Array as () => PaymentPackage[], required: true },
    currencyList: { type: Array as () => Currency[], required: true },
  },
  data() {
    return {
      showCreate: false,
    };
  },
  methods: {
    save(...attrs: any[]) {
      this.$emit("save", ...attrs);
      this.showCreate = false;
    },
    update(...attrs: any[]) {
      this.$emit("update", ...attrs);
    },
    emitDelete(...attrs: any[]) {
      this.$emit("delete", ...attrs);
    },
  },
});
